import React, { useEffect, useState } from 'react'
import './poolVerificationDetails.css'
import INCSUBPoolVerificationPoolDetailsCard from './PoolVerificationPoolDetailsCard'
import INCSUBStatusButton from '../../components/common/status Button/statusButton'
import INCSUBButton from '../../components/common/Button/INCSUBButton'
import INCSUBPoolVerificationMemberCard from './poolVerificationMemberCard'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { getPoolVerificationDetails, updateVerificationStatus } from '../../services/poolVerification'
import { setPoolVerificationList, setSelectedVerificationPool } from '../../features/poolVerifivation/poolVerificationSlice'

function INCSUBPoolVerificationDetails() {
  const details = useSelector((state) => state.poolVerification.selectedVerificationPool);
  const navigate = useNavigate();
  const [shimmer, setShimmer] = useState(false);
  const dispatch = useDispatch();
  const [btnLoader, setbtnLoader] = useState(false);
  const [isOpenPopUp, setIsOpenPopup] = useState(false);
  const [isAsk, setIsAsk] = useState(false)
  const [reason, setReason] = useState('')

  const verificationList = useSelector((state) => state.poolVerification.poolVerificationList);
  const renderPoolMembersInfo = details && details.poolMembersDtoList?.length > 0 && details.poolMembersDtoList?.map((member, index) => (
    <INCSUBPoolVerificationMemberCard member={member} index={index} />
  ))

const [reasonErr, setReasonErr]= useState(false);
  const fetchVerificationDetails = async () => {
   setShimmer(true)
    try {
      const data = await getPoolVerificationDetails(details);
      if (data && data.status === 200) {
        dispatch(setSelectedVerificationPool(data.data.data));
      }
      else if (data && data.status === 401) {
        navigate('/login');
      } else if (![200, 401].includes(data && data.status)) {
        toast.error(data.data.message);
      }
    } catch (err) {
      toast.error("somethiong went wrong");
    }
    finally {
      setShimmer(false)
    }
  }
  useEffect(() => {
    fetchVerificationDetails()
  }, [])


  const handleVerificationStatus = async (status) => {
    setbtnLoader(true);
    try {
      const data = await updateVerificationStatus(details.poolId, status, reason);
      if (data.status === 200) {
        dispatch(setSelectedVerificationPool({
          ...details,
          poolVerificationStatus: status
        }))
        toast.success("Your pool has been successfully verified!")
        // const updatedList = verificationList.verificationRequestList.map(txn =>
        //   txn.poolId === details.poolId
        //     ? {
        //       ...txn, ...{
        //         ...details,
        //         poolVerificationStatus: status
        //       }
        //     }
        //     : txn
        // );
        const updatedList = verificationList.verificationRequestList.filter(txn =>
          txn.poolId !== details.poolId
        );
        dispatch(setPoolVerificationList({
          ...verificationList,
          verificationRequestList: updatedList
        }));

      } else if (data.status === 401) {
        window.localStorage.setItem('token', null)
        navigate('/login')
      } else if (![200, 401].includes(data.status)) {
        toast.error(data.data.message);
      }
    } catch (err) {
      toast.error("Something Went Wrong")
    }
    finally {
      setbtnLoader(false);
      setIsAsk(false);
      setIsOpenPopup(false);
    }
  };

  const handleVerify = (status) => {
    handleVerificationStatus('Verified');
  }
  const handleRejectVerification = (status) => {
    if (status === 'Reject') {
      setIsOpenPopup(true);
      setIsAsk(true)
    }
  }


  async function getImageSizeFromURL(url) {
    try {
        const response = await fetch(url, { method: 'HEAD' }); // Just fetch headers
        const contentLength = response.headers.get('Content-Length');

        if (contentLength) {
            const sizeInBytes = parseInt(contentLength, 10);
            return sizeInBytes;
        } else {
            throw new Error("Content-Length not available");
        }
    } catch (error) {
        console.error("Failed to get image size:", error);
        return null;
    }
}


    /**
     * Formats a date string to 'DD Month YYYY' format (e.g., 15 May 2025)
     *
     * @function
     * @param {string} dateString - Date string to format
     * @returns {string} Formatted date
     *
     * @author govind dindewad
     */
   const formateDate = (dateString) => {
        const date = new Date(dateString);

        return new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: 'short',
            year: "numeric"
        }).format(date);
    };

  return (
    <>{!shimmer?<div className='INCSUBPoolVerificationDetails'>
      <INCSUBPoolVerificationPoolDetailsCard />
      <div className='INCSUBPoolVerificationPoolDetailsVerify'>
        <div className='INCSUBPoolVerificationPoolDetailsVerify_ctn'>
          <div className='INCSUBPoolVerificationPoolDetailsVerify_ctn_heading_status'>
            <div className='INCSUBPoolVerificationPoolDetailsVerify_ctn_heading'>
              {'Verification'}
            </div>
            <INCSUBStatusButton status={details?.poolVerificationStatus} />
          </div>
          <div className='INCSUBPoolVerificationPoolDetailsVerify_container'>
            <div className='INCSUBPoolVerificationPoolDetailsVerify_ctn_credentials'>
              <div className='INCSUBPoolVerificationDetails_verifiedby_heading'>
                <div className='INCSUBPoolVerification_status_heading_disc'></div>
                {'Credentials:'}
              </div>
              <div className='INCSUBPoolVerificationPoolDetailsCredentilals_cards'>
                {details?.platformCredentialType === 'OTP' ? <div className='INCSUBPoolVerificationPoolDetailsVerify_ctn_userid'>
                  <div className='INCSUBPoolVerificationCredentials_Img_userId'>
                    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.17491 9.98177C6.47852 9.98177 4.3138 7.81706 4.3138 5.12066C4.3138 2.46224 6.47852 0.259548 9.17491 0.259548C11.8333 0.259548 14.036 2.46224 14.036 5.12066C14.036 7.81706 11.8333 9.98177 9.17491 9.98177ZM12.5549 11.197C15.3652 11.197 17.6819 13.5137 17.6819 16.324V17.8811C17.6819 18.9065 16.8464 19.704 15.8589 19.704H2.49089C1.46549 19.704 0.667969 18.9065 0.667969 17.8811V16.324C0.667969 13.5137 2.94661 11.197 5.75694 11.197H6.40256C7.23806 11.6148 8.1875 11.8047 9.17491 11.8047C10.1623 11.8047 11.0738 11.6148 11.9093 11.197H12.5549Z" fill="white" />
                    </svg>
                  </div>
                  <div className='INCSUBPoolVerification_verifiedby_userId_ctn'>
                    <div className='INCSUBPoolVerification_verifiedby_userId_head'>
                      {'Mobile No'}
                    </div>
                    <div className='INCSUBPoolVerification_verifiedby_userId_text'>
                      {details?.mobileNumberForVerification}
                    </div>
                  </div>
                </div> : (details?.platformCredentialType==='INVITE_LINK'?<div className='INCSUBPoolVerificationPoolDetailsVerify_ctn_userid'>
                  <div className='INCSUBPoolVerificationCredentials_Img_userId'>
                    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.17491 9.98177C6.47852 9.98177 4.3138 7.81706 4.3138 5.12066C4.3138 2.46224 6.47852 0.259548 9.17491 0.259548C11.8333 0.259548 14.036 2.46224 14.036 5.12066C14.036 7.81706 11.8333 9.98177 9.17491 9.98177ZM12.5549 11.197C15.3652 11.197 17.6819 13.5137 17.6819 16.324V17.8811C17.6819 18.9065 16.8464 19.704 15.8589 19.704H2.49089C1.46549 19.704 0.667969 18.9065 0.667969 17.8811V16.324C0.667969 13.5137 2.94661 11.197 5.75694 11.197H6.40256C7.23806 11.6148 8.1875 11.8047 9.17491 11.8047C10.1623 11.8047 11.0738 11.6148 11.9093 11.197H12.5549Z" fill="white" />
                    </svg>
                  </div>
                  <div className='INCSUBPoolVerification_verifiedby_userId_ctn'>
                    <div className='INCSUBPoolVerification_verifiedby_userId_head'>
                      {'Invite Link'}
                    </div>
                    <div className='INCSUBPoolVerification_verifiedby_userId_text'>
                     <a href={details?.inviteLinkForVerification} rel="noreferrer" target="_blank" style={{cursor:"pointer"}}> {details?.inviteLinkForVerification}</a>
                    </div>
                  </div>
                </div>:<><div className='INCSUBPoolVerificationPoolDetailsVerify_ctn_userid'>
                  <div className='INCSUBPoolVerificationCredentials_Img_userId'>
                    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.17491 9.98177C6.47852 9.98177 4.3138 7.81706 4.3138 5.12066C4.3138 2.46224 6.47852 0.259548 9.17491 0.259548C11.8333 0.259548 14.036 2.46224 14.036 5.12066C14.036 7.81706 11.8333 9.98177 9.17491 9.98177ZM12.5549 11.197C15.3652 11.197 17.6819 13.5137 17.6819 16.324V17.8811C17.6819 18.9065 16.8464 19.704 15.8589 19.704H2.49089C1.46549 19.704 0.667969 18.9065 0.667969 17.8811V16.324C0.667969 13.5137 2.94661 11.197 5.75694 11.197H6.40256C7.23806 11.6148 8.1875 11.8047 9.17491 11.8047C10.1623 11.8047 11.0738 11.6148 11.9093 11.197H12.5549Z" fill="white" />
                    </svg>
                  </div>
                  <div className='INCSUBPoolVerification_verifiedby_userId_ctn'>
                    <div className='INCSUBPoolVerification_verifiedby_userId_head'>
                      {'userId'}
                    </div>
                    <div className='INCSUBPoolVerification_verifiedby_userId_text'>
                      {details?.usernameForVerification}
                    </div>
                  </div>
                </div>
                  <div className='INCSUBPoolVerificationPoolDetailsVerify_ctn_userid'>
                    <div className='INCSUBPoolVerificationCredentials_Img_passward'>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.9531 8.46276C21.7863 6.80331 21.0408 5.25551 19.8471 4.09076L19.7391 4.00276C18.8791 3.16684 17.8209 2.56313 16.6637 2.24828C15.5065 1.93343 14.2883 1.91777 13.1234 2.20278C11.9585 2.48778 10.8851 3.0641 10.004 3.87763C9.12288 4.69117 8.46292 5.71526 8.08606 6.85376C7.58138 8.37895 7.60888 10.0302 8.16406 11.5378L2.21406 17.5108C2.14614 17.5786 2.09228 17.6592 2.05556 17.7479C2.01883 17.8367 1.99997 17.9317 2.00006 18.0278V21.2678C1.99885 21.3641 2.01693 21.4598 2.05322 21.5491C2.08952 21.6384 2.1433 21.7195 2.21141 21.7877C2.27952 21.8559 2.36058 21.9098 2.44982 21.9462C2.53906 21.9826 2.63468 22.0008 2.73106 21.9998H5.98006C6.08578 22.0015 6.19059 21.98 6.28705 21.9367C6.38351 21.8934 6.46924 21.8294 6.53817 21.7492C6.60709 21.669 6.6575 21.5746 6.68583 21.4727C6.71415 21.3709 6.71969 21.264 6.70206 21.1598L6.55506 20.1848L7.46206 20.3308C7.57717 20.3507 7.69534 20.3434 7.80715 20.3095C7.91896 20.2757 8.02132 20.2162 8.10606 20.1358L9.73506 18.5058C9.8176 18.4243 9.87925 18.3242 9.91477 18.2138C9.95029 18.1034 9.95862 17.9861 9.93906 17.8718L9.78306 16.8958L10.7591 17.0418C10.8734 17.0604 10.9906 17.0515 11.1008 17.0158C11.2111 16.9802 11.3112 16.9188 11.3931 16.8368L12.4751 15.7438C13.6015 16.162 14.8161 16.2858 16.0038 16.1035C17.1915 15.9211 18.3129 15.4387 19.2621 14.7018C20.2116 13.9648 20.958 12.9982 21.4307 11.893C21.9034 10.7878 22.087 9.58049 21.9641 8.38476L21.9531 8.46276ZM17.4281 10.8348C17.0112 11.2618 16.4739 11.5514 15.8881 11.6648C15.6951 11.7033 15.4988 11.7227 15.3021 11.7228C14.908 11.7219 14.5177 11.6458 14.1521 11.4988C13.6029 11.2695 13.1344 10.882 12.8061 10.3858C12.4712 9.89392 12.294 9.31177 12.2981 8.71676C12.2981 8.12324 12.4741 7.54305 12.804 7.04962C13.1338 6.55619 13.6026 6.17169 14.1511 5.94476C14.7012 5.72048 15.3052 5.6629 15.8879 5.77918C16.4705 5.89546 17.0061 6.18047 17.4281 6.59876C17.9845 7.16327 18.2965 7.92409 18.2965 8.71676C18.2965 9.50943 17.9845 10.2703 17.4281 10.8348Z" fill="#FEFEFE" />
                      </svg>

                    </div>
                    <div className='INCSUBPoolVerification_verifiedby_userId_ctn'>
                      <div className='INCSUBPoolVerification_verifiedby_userId_head'>
                        {'Passward'}
                      </div>
                      <div className='INCSUBPoolVerification_verifiedby_userId_text'>
                        {details?.passwordForVerification}
                      </div>
                    </div>
                  </div></>)}

              </div>
            </div>
            <div className='INCSUBPoolVerificationPoolDetailsVerify_ctn_credentials'>
              <div className='INCSUBPoolVerificationDetails_verifiedby_heading'>
                <div className='INCSUBPoolVerification_status_heading_disc'></div>
                {'Attachments:'}
              </div>
              <div className='INCSUBPoolVerificationPoolDetailsCredentilals_cards'>
                <div className='INCSUBPoolVerificationPoolDetails_attachments'>
                  <div className='INCSUBPoolVerificationPoolDetails_attachments_hlder'>
                    <div className='INCSUBPoolVerificationPoolDetails_attachments_hlder_text'>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.75391 10.5C10.0494 10.5 10.342 10.4418 10.6149 10.3287C10.8879 10.2157 11.136 10.0499 11.3449 9.84099C11.5538 9.63206 11.7196 9.38402 11.8326 9.11104C11.9457 8.83806 12.0039 8.54547 12.0039 8.25C12.0039 7.95453 11.9457 7.66194 11.8326 7.38896C11.7196 7.11598 11.5538 6.86794 11.3449 6.65901C11.136 6.45008 10.8879 6.28434 10.6149 6.17127C10.342 6.0582 10.0494 6 9.75391 6C9.15717 6 8.58487 6.23705 8.16292 6.65901C7.74096 7.08097 7.50391 7.65326 7.50391 8.25C7.50391 8.84674 7.74096 9.41903 8.16292 9.84099C8.58487 10.2629 9.15717 10.5 9.75391 10.5Z" fill="#4880FF" />
                        <path d="M21 21C21 21.7956 20.6839 22.5587 20.1213 23.1213C19.5587 23.6839 18.7956 24 18 24H6C5.20435 24 4.44129 23.6839 3.87868 23.1213C3.31607 22.5587 3 21.7956 3 21V3C3 2.20435 3.31607 1.44129 3.87868 0.87868C4.44129 0.316071 5.20435 0 6 0L14.25 0L21 6.75V21ZM6 1.5C5.60218 1.5 5.22064 1.65804 4.93934 1.93934C4.65804 2.22064 4.5 2.60218 4.5 3V18L7.836 14.664C7.95422 14.5461 8.10843 14.4709 8.27417 14.4506C8.43992 14.4302 8.60773 14.4657 8.751 14.5515L12 16.5L15.2355 11.97C15.2988 11.8815 15.3806 11.8078 15.4753 11.754C15.5699 11.7003 15.6751 11.6678 15.7836 11.6588C15.8921 11.6498 16.0012 11.6645 16.1034 11.702C16.2056 11.7394 16.2985 11.7986 16.3755 11.8755L19.5 15V6.75H16.5C15.9033 6.75 15.331 6.51295 14.909 6.09099C14.4871 5.66903 14.25 5.09674 14.25 4.5V1.5H6Z" fill="#4880FF" />
                      </svg>
                      <p><span>{'Picture.png'}</span>{'  '}<span style={{ color: 'rgba(0, 0, 0, 0.7)', fontSize: '10px', fontWeight: '600' }}>{}</span></p>
                    </div>
                    <span style={{ color: 'rgba(72, 128, 255, 1)', fontSize: '12px', fontWeight: '600', cursor: "pointer" }} onClick={() => window.open(details?.verificationImage)}>{'Preview'}</span>
                  </div>

                </div>
              </div>
            </div>

            <div className='INCSUBPoolVerificationPoolDetailsVerify_ctn_credentials'>
              <div className='INCSUBPoolVerificationDetails_verifiedby_heading'>
                <div className='INCSUBPoolVerification_status_heading_disc'></div>
                {'Available time slots for the verification process:'}
              </div>
              <div className='INCSUBPoolInfo_card_pool_details'>
                <div className='INCSUBPoolVerificationPoolDetailsCredentilals_cards slot'>
                  <div className='INCSUBPoolInfo_card_pool_details_divs'>
                    <div className='INCSUBPoolInfo_card_pool_details_name_img'>
                      <div className='INCSUBPoolInfo_card_pool_details_hostedby_img'>
                        <img className='INCSUB_UserImgTag' src={'/assets/images/pool verification/morning.png'} alt={`${'default'} img`} />
                      </div>
                      <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
                        <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>{'Morning'}</p>
                        <p className='INCSUBPoolInfo_card_pool_details_hostedbyname_p' style={{ display: !details?.morningAvailableTimeSlotFrom ? "none" : null }}>{details?.morningAvailableTimeSlotFrom + " - " + details?.morningAvailableTimeSlotTo}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='INCSUBPoolVerificationPoolDetailsCredentilals_cards slot'>
                  <div className='INCSUBPoolInfo_card_pool_details_divs'>
                    <div className='INCSUBPoolInfo_card_pool_details_name_img'>
                      <div className='INCSUBPoolInfo_card_pool_details_hostedby_img'>
                        <img className='INCSUB_UserImgTag' src={'/assets/images/pool verification/afternoon.png'} alt={`${'default'} img`} />
                      </div>
                      <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
                        <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>{'Afternoon'}</p>
                        <p className='INCSUBPoolInfo_card_pool_details_hostedbyname_p' style={{ display: !details?.afternoonAvailableTimeSlotFrom ? "none" : null }}>{details?.afternoonAvailableTimeSlotFrom + " - " + details?.afternoonAvailableTimeSlotTo}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='INCSUBPoolVerificationPoolDetailsCredentilals_cards slot'>
                  <div className='INCSUBPoolInfo_card_pool_details_divs_last'>
                    <div className='INCSUBPoolInfo_card_pool_details_name_img'>
                      <div className='INCSUBPoolInfo_card_pool_details_hostedby_img'>
                        <img className='INCSUB_UserImgTag' src={'/assets/images/pool verification/night.png'} alt={`${'default'} img`} />
                      </div>
                      <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
                        <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>{'Night'}</p>
                        <p className='INCSUBPoolInfo_card_pool_details_hostedbyname_p' style={{ display: !details?.eveningAvailableTimeSlotFrom ? "none" : null }}>{details?.eveningAvailableTimeSlotFrom + " - " + details?.eveningAvailableTimeSlotTo}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {
            details && details.poolVerificationStatus === 'Pending' ?
              <div className='INCSUBPoolVerificationPoolDetails_btns'>
                <INCSUBButton text={'Reject'} color={'rgba(32, 34, 36, 0.65)'} background='rgba(32, 34, 36, 0.1)' clickFun={handleRejectVerification} />
                <INCSUBButton text={'Verify'} color='' background='' clickFun={handleVerify} />
              </div> : null
          }
        </div>
        <div className='INCSUBPoolMemberDetail_ctn_right'>
          <div className='INCSUBPoolVerification_heading'>{'Member'}</div>
          <div className='INCSUBPoolVerification_member_container'>
            {renderPoolMembersInfo}
          </div>
          {details?.verifiedByName && <div className='INCSUBPoolVerification_verifiedby_ctn'>
                    <div className='INCSUBPoolVerification_verifiedby_heading'>
                        <div className='INCSUBPoolVerification_status_heading_disc'></div>
                        Verified By:
                    </div>
                    <div className='INCSUBPoolVerification_verifiedby_imgname'>
                        <div className='INCSUBPoolVerification_verifiedby_imgname_hld'>
                            {details?.verifiedByImage && (
                                <div className='INCSUB_UserImg'>
                                    <img
                                        className='INCSUB_UserImgTag'
                                        src={details?.verifiedByImage || '/assets/icons/common/defaultImage.png'}
                                        alt='default img'
                                    />
                                </div>
                            )}
                            <div className='INCSUBPoolVerification_verifiedby_imgnametext'>
                                <p className='INCSUBRolemanagment_name'>{details?.verifiedByName}</p>
                                <p className='INCSUBRolemanagment_no'>{details?.verifiedByRole}</p>
                            </div>
                        </div>
                        <div className='INCSUBPoolVerification_verifiedby_date'>
                            {details?.verificationDate?formateDate(details?.verificationDate):"-"}
                        </div>
                    </div>
                </div>}
        </div>
      </div>
      {isOpenPopUp ?
        <div className='INCSUBCategory_permission_popup'>{
          isAsk ?
            <div className='INCSUBCategory_ask_container' >
              <div className='INCSUBCategory_ask' style={{ display: btnLoader ? 'none' : null }}>
                <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="49.0815" cy="46.0102" r="32.0883" fill="#FF6565" />
                  <path d="M59 37L41 55" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M41 37L59 55" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                  <circle cx="13.778" cy="7.87368" r="7.87368" fill="#FF6565" fill-opacity="0.2" />
                  <circle cx="93.1719" cy="15.749" r="5.90526" fill="#FF6565" fill-opacity="0.2" />
                  <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#FF6565" fill-opacity="0.2" />
                  <circle cx="34.777" cy="91.2028" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                  <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                  <circle cx="89.235" cy="58.3903" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                  <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                </svg>
                <div className='INCSUBCategory_permission_header' style={{ fontSize: "17px" }}>
                  Are you sure you want to reject the verification of this pool?
                </div>
                <div className='INCSUBCategory_permission_btn_container'>
                  <div className="INCSUBCategory_image_upload_btn">
                    <div className='INCSUBCategory_upload_btn' onClick={() => setIsAsk(false)} disabled={btnLoader}>Yes, Reject</div>
                    <div className='upload_cancel_btn' onClick={() => {
                      setIsOpenPopup(false);
                      setIsAsk(false);
                    }}>Cancel</div>
                  </div>
                </div>
              </div>
              {
                btnLoader ? <div className='categoryloader' /> : null
              }
            </div> : <div className='INCSUBCategory_ask_container'>
              <div className='INCSUBCategory_permission_header'>
                Please enter a reason for rejecting the pool.
              </div>
              <input type='text' name='username' placeholder='Type Here...  ' value={reason} onChange={(e) => setReason(e.target.value)} style={{border:reasonErr && reason===''?"1px solid red":null}}/>
              <div className='INCSUBCategory_permission_btn_container'>
                <div className="INCSUBCategory_image_upload_btn">
                  <div className='INCSUBCategory_upload_btn' onClick={() => {
                    if(reason===""){
                      setReasonErr(true)
                      return
                    }
                    handleVerificationStatus("Rejected");
                  }}>Yes, Reject</div>
                  <div className='upload_cancel_btn' onClick={() => {
                    setIsOpenPopup(false);
                    setIsAsk(false);
                  }}>No</div>
                </div>
              </div>
            </div>
        }


        </div> : null
      }

    </div>:<div className='verification_details_shimmer'><div className='verification_loader'/></div>}
    </>
  )
}

export default INCSUBPoolVerificationDetails
